import { Injectable } from '@angular/core';
import { WebapiService } from './webapi.service';
import * as _ from "lodash";

@Injectable()
export class GsonCoreService {

  public HTTP_HEADER_KEY: string = "X-AUTH-TOKEN";
  public READ_SERVICE_PATH: string = "rs/v1/gson/read/";

  constructor(private http: WebapiService) {
    
  }
  singleRead(resource:string){
    return this.http.sGet(this.READ_SERVICE_PATH + resource);
  }
  read(resource:string,data:any){    
    return this.http.sPost(this.READ_SERVICE_PATH + resource,data);
  }
}


// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/services/core/gson.core.service.ts